import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { useMst } from "../../../../../mobx";
import { SimpleTableColumns } from "../../../../common/SimpleTable/SimpleTable";
import { SimpleTable } from "../../../../common/SimpleTable";
import { useHistory } from "react-router-dom";
import { stringify } from "query-string";
import { IconButton } from "@mui/material";
import { Edit } from "@mui/icons-material";
import QuestionsFilters from "../../../../Filters/QuestionsFilters/QuestionsFilters";
import { useQueryParamsEnhanced } from "../../../../../helpers/hooks/useQueryParamsEnhanced";
import {FeatureAppearance} from "../../../../FeatureAppearance";

export default observer(function QuestionsTable() {
	const [loading, setLoading] = useState(false);
	const { questionsStore } = useMst();
	const { getQuestions, getQuestionsTableData } = questionsStore;
	const { total } = questionsStore.page;
	const history = useHistory();
	const params = useQueryParamsEnhanced();
	const page = params["page[number]"];
	const size = params["page[size]"];

	useEffect(() => {
		if (!page || !size) {
			history.push({
				search: stringify({
					...params,
					"page[size]": "15",
					"page[number]": "1",
				}),
			});
		} else {
			getQuestionsAsync();
		}

		async function getQuestionsAsync() {
			setLoading(true);
			await getQuestions({
				...params,
				"page[size]": size,
				"page[number]": page,
			});
			setLoading(false);
		}
	}, [page, size]);

	const columns: SimpleTableColumns[] = [
		{
			field: "number",
			headerName: "Номер задачи",
		},
		{
			field: "class",
			headerName: "Тип вопроса",
		},
		{
			field: "title",
			headerName: "Заголовок",
		},
		{
			field: "order",
			headerName: "Порядок",
			align: "center",
		},
		{
			field: "category",
			headerName: "Используется для пробных экзаменов",
			align: "right",
		},
	];

	return (
		<div style={{ width: "100%" }}>
			<QuestionsFilters />
			<SimpleTable
				columns={columns}
				rows={getQuestionsTableData}
				loading={loading}
				page={page ? parseFloat(page) - 1 : undefined}
				rowsPerPage={size ? parseFloat(size) : undefined}
				count={total}
				onPageChange={(_, page) =>
					history.push({
						search: stringify({
							...params,
							"page[size]": size,
							"page[number]": (page + 1).toString(),
						}),
					})
				}
				renderControls={(id: string) => (
					<FeatureAppearance feature={["questions.questions.any.update"]}>
						{(featureExist) => {
							return featureExist
								? (
									<IconButton
										onContextMenu={(e) => e.preventDefault()}
										onMouseDown={(e) => {
											if (e.button === 0) {
												history.push(`/questions/edit/${id}`);
											} else if (e.button === 2) {
												window.open(`/questions/edit/${id}`, "_blank");
											}
										}}
									>
										<Edit color={"primary"} fontSize={"small"} />
									</IconButton>
								)
								: null
						}}
					</FeatureAppearance>
				)}
			/>
		</div>
	);
});
